function InfoRow({ icon: Icon, label, color, value }) {
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, fontSize: 13, color: "#4B5563" }}>
      <Icon style={{ width: 14, height: 14, color: color || "#6B7280", flexShrink: 0 }} />
      <span>{label}</span>
    </div>
  );
}
export default InfoRow;